import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { isAdminRole } from "@/lib/roles";
import { Button } from "@/components/ui/button";
import { BrandLogo } from "@/components/Brand";

const PUBLIC_LINKS = [["/mentors", "Mentors", "nav-mentors-link"], ["/assessments", "Assessments", "nav-assessments-link"], ["/contact", "Contact us", "nav-contact-link"]];

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200/60">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-24 flex items-center justify-between gap-4">
        <BrandLogo to={user ? (isAdminRole(user) ? "/admin" : "/dashboard") : "/"} testId="navbar-logo" />

        {user ? (
          <div className="flex items-center gap-3">
            {isAdminRole(user) ? (
              <button onClick={() => navigate("/admin")} className="hidden sm:block font-body text-sm text-slate-600 hover:text-primary transition-colors" data-testid="navbar-admin-link">
                Admin panel
              </button>
            ) : (
              <button onClick={() => navigate("/dashboard")} className="hidden sm:block font-body text-sm text-slate-600 hover:text-primary transition-colors" data-testid="navbar-dashboard-link">
                Dashboard
              </button>
            )}
            {user.picture && <img src={user.picture} alt={user.name} className="w-8 h-8 rounded-full border border-slate-200" data-testid="navbar-avatar" />}
            <span className="hidden md:block font-body text-sm font-medium text-slate-700">{user.name}</span>
            <Button variant="ghost" size="sm" onClick={logout} data-testid="navbar-logout-btn" className="text-slate-600 hover:text-destructive">
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        ) : (
          <nav className="flex items-center gap-1 sm:gap-2">
            {PUBLIC_LINKS.map(([to, label, tid]) => (
              <Link key={to} to={to} data-testid={tid}
                className={`hidden sm:block px-3 py-1.5 rounded-lg font-body text-sm transition-colors ${pathname.startsWith(to) ? "text-primary font-semibold bg-primary/5" : "text-slate-600 hover:text-primary"}`}>
                {label}
              </Link>
            ))}
            <Button onClick={() => navigate("/access")} size="sm" data-testid="nav-access-btn"
              className="rounded-full h-9 px-4 font-heading font-bold ml-1">
              Enter code
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Navbar;
